export const GA_TRACKING_ID = "GTM-MZLPRCD" //Old - ZXP2821QD4 changed to G-ZXP2821QD4 on 28th August 2025

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = url => {
  try {
    window.gtag("config", GA_TRACKING_ID, {
      page_path: url,
    })
  } catch (error) {
    console.error("GTag Error:", error)
  }
}

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const event = ({ action, category, label, value }) => {
  window.gtag("event", action, {
    event_category: category,
    event_label: label,
    value: value,
  })
}